"use client";

import React, { useState, useEffect } from 'react';
import { ThemeProvider, useTheme, ThemeProviderProps } from 'next-themes';
import MainNav from '../navigation/MainNav';
import Footer from './Footer';
import { Toaster } from "@/components/ui/toaster";
import { ScrollRestoration } from '@/components/ScrollRestoration';

interface AppLayoutProps {
  children: React.ReactNode;
}

const ThemeProviderWrapper: React.FC<ThemeProviderProps> = ({ children, attribute, defaultTheme, enableSystem }) => {
  return (
    <ThemeProvider attribute={attribute} defaultTheme={defaultTheme} enableSystem={enableSystem}>
      {children}
    </ThemeProvider>
  );
};

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme && savedTheme !== theme) {
      setTheme(savedTheme);
    }
  }, [theme, setTheme]);

  if (!mounted) {
    return null;
  }

  return (
    <ThemeProviderWrapper attribute="class" defaultTheme="light" enableSystem>
      <div className="flex flex-col min-h-screen">
        <MainNav />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
        <div aria-live="polite">
        <Toaster />
        </div>
        <ScrollRestoration />
      </div>
    </ThemeProviderWrapper>
  );
};

export default AppLayout;